import React, { useEffect, useRef } from 'react';
import { AlertTriangle } from 'lucide-react';
import './ConfirmDialog.css';

const ConfirmDialog = ({ 
  isOpen, 
  onConfirm, 
  onCancel, 
  title = "Confirm Action", 
  message = "Are you sure you want to proceed?",
  confirmText = "Delete",
  cancelText = "Cancel",
  variant = "danger" // danger, warning, info
}) => {
  const dialogRef = useRef(null);
  const confirmButtonRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      // Focus the cancel button by default for safety
      const cancelButton = dialogRef.current?.querySelector('[data-cancel-button]');
      if (cancelButton) {
        cancelButton.focus();
      }

      // Handle escape key
      const handleEscape = (e) => {
        if (e.key === 'Escape') {
          onCancel();
        }
      };

      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
    }
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <div className="confirm-dialog-overlay" onClick={handleOverlayClick}>
      <div className={`confirm-dialog confirm-dialog--${variant}`} ref={dialogRef} role="alertdialog" aria-labelledby="dialog-title" aria-describedby="dialog-message">
        <div className="confirm-dialog__header">
          <div className="confirm-dialog__icon">
            <AlertTriangle size={24} />
          </div>
          <h3 id="dialog-title" className="confirm-dialog__title">
            {title}
          </h3>
        </div>
        
        <div className="confirm-dialog__content">
          <p id="dialog-message" className="confirm-dialog__message">
            {message}
          </p>
        </div>
        
        <div className="confirm-dialog__actions">
          <button
            type="button"
            className="confirm-dialog__button confirm-dialog__button--cancel"
            onClick={onCancel}
            data-cancel-button
          >
            {cancelText}
          </button>
          <button
            type="button"
            className={`confirm-dialog__button confirm-dialog__button--confirm confirm-dialog__button--${variant}`}
            onClick={onConfirm}
            ref={confirmButtonRef}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;